export const froalaKey = () =>
  (typeof document !== "undefined" &&
    document.querySelector('meta[name="froala-key"]')?.getAttribute("content")) ||
  "";
